// ImportacionesRoutesXL - Sprint 44 Fase 3 Vista 10.
import { Routes, Route } from 'react-router-dom';
import ImportacionesListXL from './ImportacionesListXL';
import ImportacionFormXL from './ImportacionFormXL';

export default function ImportacionesRoutesXL() {
  return (
    <Routes>
      <Route index element={<ImportacionesListXL />} />
      <Route path="nueva" element={<ImportacionFormXL />} />
      <Route path=":id" element={<ImportacionFormXL />} />
    </Routes>
  );
}
